// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__17OkW","title":"FrontImage_title__1ch3U"};